import React from 'react';

import styled, { css } from 'styled-components';

import { IPickerAspectOptionContainer } from './types';

const OuterContainer = styled.label<IPickerAspectOptionContainer>`
  position: relative;
  background-color: ${Styles.color.cardBackground};
  border-radius: 10px;
  border: 0;
  color: ${Styles.color.black};
  display: flex;
  align-items: center;
  margin: 0;
  padding: 1rem;
  min-height: 100px;
  position: relative;
  text-align: left;
  transition: border 0.3s;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const SelectedState = styled.div<{ selected?: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: solid 2.5px ${Styles.color.primary};
  border-radius: 10px;
  transition: border 0.3s;

  ${p =>
    p.selected
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
          /* if not selected but in hover state, show selected state with grey border */
          &:not([disabled]):hover {
            border-color: ${Styles.color.grey.four};
            transition: opacity 0.3s;
            opacity: 1;
          }
        `}

  &:not([disabled]):hover {
    cursor: pointer;
  }
`;

const PickerAspectOptionContainer: React.FC<IPickerAspectOptionContainer> = props => (
  <OuterContainer {...props}>
    <SelectedState selected={props.selected} />
    {props.children}
  </OuterContainer>
);

export default PickerAspectOptionContainer;
